import { styled } from 'styled-components';

export const Title = styled.span`
  color: #000;
  text-align: center;
  font-feature-settings: 'case' on;
  font-family: Playfair Display;
  font-size: 33px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Message = styled(Title)`
  color: #000;
  text-align: center;
  font-feature-settings: 'case' on;

  font-size: 16px;
  font-family: 'Poppins-Regular';

  letter-spacing: -0.2px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
